import { FuelTypography } from '@frete.com/fuel-react';
import Grid from '~components/dumbs/Grid';
import * as Styled from './styled';

function RightSide() {
  return (
    <Styled.Background>
      <Grid container direction="column" spacing={10}>
        <Grid container>
          <Grid $fill></Grid>
          <Grid xs={5} align="end">
            <FuelTypography
              size="display-sm"
              weight="bold"
              color="neutral-inverted"
            >
              Solução financeira completa para o seu negócio
            </FuelTypography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid $fill></Grid>
          <Grid xs={4} align="end">
            <FuelTypography color="neutral-inverted" size="heading-sm">
              Abra agora sua{' '}
              <FuelTypography
                weight="bold"
                color="neutral-inverted"
                size="heading-sm"
              >
                Conta PJ Fretebras
              </FuelTypography>{' '}
              grátis e tenha oferta de crédito para antecipar seus recebíveis e
              ajudar a alavancar o seu negócio.
            </FuelTypography>
          </Grid>
        </Grid>
      </Grid>
    </Styled.Background>
  );
}

export default RightSide;
